import * as React from 'react';

import { cn } from '../../lib/utils';
import { formaterResultat } from './TableauRapport';
import {
  formatPourcentSigne,
  margePourcent,
  montant,
  nombre,
  variationPourcent,
} from './reportHelpers';

/**
 * Aperçu du mois dans la bande du mois: deux mini-barres (recettes, charges)
 * à la même échelle, la marge, et l'évolution du résultat par rapport au
 * mois précédent quand il est connu.
 */
const ApercuMois = ({ recettes, charges, resultat, precedent, libellePrecedent, className }) => {
  const r = montant(recettes);
  const c = montant(charges);
  const base = Math.max(r, c, 1);
  const marge = margePourcent(r, resultat);
  const ecartResultat = precedent ? montant(resultat) - montant(precedent.resultat) : null;
  const evolutionRecettes = precedent ? variationPourcent(r, precedent.recettes) : null;

  return (
    <div
      className={cn('flex min-w-0 items-center gap-3 text-xs text-muted-foreground', className)}
      data-testid="apercu-mois"
    >
      <div
        className="w-24 shrink-0 space-y-1"
        role="img"
        aria-label={`Recettes ${nombre(r) || '0'}, charges ${nombre(c) || '0'}`}
        title={`Recettes ${nombre(r) || '0'} · Charges ${nombre(c) || '0'}`}
      >
        <span className="block h-1.5 rounded-full bg-muted">
          <span className="block h-full rounded-full bg-success" style={{ width: `${(r / base) * 100}%` }} />
        </span>
        <span className="block h-1.5 rounded-full bg-muted">
          <span className="block h-full rounded-full bg-flame" style={{ width: `${(c / base) * 100}%` }} />
        </span>
      </div>
      <p className="whitespace-nowrap">
        Marge{' '}
        <span
          className={cn(
            'font-semibold tabular-nums',
            marge === null ? 'text-muted-foreground' : marge < 0 ? 'text-destructive' : 'text-foreground',
          )}
        >
          {marge === null ? 'sans recette' : formatPourcentSigne(marge)}
        </span>
      </p>
      {precedent && (
        <p className="hidden min-w-0 truncate xl:block" title={`Par rapport à ${libellePrecedent}`}>
          Depuis {libellePrecedent} :{' '}
          <span
            className={cn(
              'font-semibold tabular-nums',
              ecartResultat < 0 ? 'text-destructive' : ecartResultat > 0 ? 'text-success' : 'text-foreground',
            )}
          >
            {formaterResultat(ecartResultat) || '0'}
          </span>{' '}
          de résultat
          {evolutionRecettes !== null && (
            <>
              {' · recettes '}
              <span className="font-semibold tabular-nums text-foreground">
                {formatPourcentSigne(evolutionRecettes, { signe: true })}
              </span>
            </>
          )}
        </p>
      )}
    </div>
  );
};

export default ApercuMois;
